import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="home-about-row">
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I bridge the gap between backend engineering, DevOps, and machine
              learning.
              <br />
              <br />I specialize in developing high-availability applications
              with
              <i>
                <b className="purple"> Node.js, NestJS, and ASP.NET </b>
              </i>
              backed by a deep understanding of data modeling and predictive
              analytics.
              <br />
              <br />
              My key areas of interest are
              <i>
                <b className="purple"> Web, AI, Mobile, and Data </b>
              </i>
              . I build reliable systems first, then optimize for speed, scale,
              and product impact.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src="/avatar.svg"
                className="img-fluid home-avatar-image"
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
